module.exports = __webpack_public_path__ + "static/img/banner3.88d23f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner3.jpg
// module id = pwst
// module chunks = 2